
import { Component, Vue } from "vue-property-decorator";

import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";

import IMAGE from "@/assets/images/upload-file.svg";

const IMAGE_PROPS = {
  width: 32,
  height: 32,
};

const MESSAGES = {
  title: "Preview will be available \nafter uploading a file",
};

@Component({
  components: {
    UploaderState,
  },
})
export default class EmptyUploaderState extends Vue {
  IMAGE = IMAGE;
  IMAGE_PROPS = IMAGE_PROPS;
  MESSAGES = MESSAGES;
}
